import React from "react";

export default function Slide(
  { className = "", onClick, attributes = {}, children = null, key, ref }
) {
  return (
    <div
      key={key}
      className={className}
      {...attributes}
      ref={ref}
      onClick={onClick}
    >
      {children}
    </div>
  );
};
